import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import React, { useState, useRef, useEffect } from "react";
import { DayPicker } from "react-day-picker";

import "react-day-picker/dist/style.css";
import { formatDate, formatDateReverse } from "../utils/helps";

const DatePicker = ({
  name,
  onChange,
  title,
  value,
  error,
  disabled = false,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [coord, setCoord] = useState(null);
  const calendarRef = useRef(null);

  const handleDateChange = (date) => {
    setIsCalendarOpen(false);
    onChange(name, formatDateReverse(date));
  };

  const toggleCalendar = () => {
    const coords = getAbsoluteCoords(calendarRef.current);
    setCoord(coords);

    setIsCalendarOpen((prev) => !prev);
  };

  // const fixedDiv = document.querySelector('div.fixed.inset-0 > div');

  // if(fixedDiv) {
  //   fixedDiv.addEventListener('scroll', () => {
  //     console.log('scroll')
  //     if (calendarRef.current) {
  //       const coords = getAbsoluteCoords(calendarRef.current);
  //       setCoord(coords);
  //     }
  //   })
  // }

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsCalendarOpen(false);
    }
  };

  const getAbsoluteCoords = (element) => {
    const rect = element.getBoundingClientRect();
    return {
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    };
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={calendarRef}>
      <div className="relative flex items-center">
        <input
          type="text"
          name={name}
          placeholder={title}
          value={value ? formatDate(value) : ""}
          onClick={toggleCalendar}
          readOnly
          disabled={disabled}
          // onChange={}
          className={`input input-bordered w-full cursor-pointer pr-10 h-11${
            error ? "input-error" : ""
          }`}
        />
        <CalendarDaysIcon
          className="w-5 h-5 absolute right-3 text-gray-500 cursor-pointer"
          onClick={disabled ? null : toggleCalendar}
        />
      </div>
      {isCalendarOpen && (
        <div
          className="absolute left-0 mt-2 bg-white shadow-lg border rounded-md p-4 z-50"
          style={{
            left: `${coord.left}px`,
            top: `calc(${coord.top}px + 2.5rem)`,
          }}
        >
          <DayPicker
            mode="single"
            selected={value}
            onSelect={handleDateChange}
            captionLayout="dropdown"
            endMonth={new Date(2035, 11)}
          />
        </div>
      )}
    </div>
  );
};

export default DatePicker;
